// extracted by mini-css-extract-plugin
export default {"imprint":"Imprint_imprint__eSo1J","Background":"Imprint_Background__gIDnA","TopPart":"Imprint_TopPart__fe9pu"};